import { ReactNode, HTMLAttributes } from 'react';
import clsx from 'clsx';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  variant?: 'default' | 'warning' | 'success' | 'error';
}

export default function Card({
  children,
  className,
  hover = false,
  padding = 'md',
  variant = 'default',
  ...props
}: CardProps) {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const variantClasses = {
    default: hover ? 'card-hover' : 'card',
    warning: 'card-warning',
    success: 'card-success',
    error: 'card-error',
  };

  return (
    <div
      className={clsx(
        variantClasses[variant],
        paddingClasses[padding],
        hover && 'cursor-pointer',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
